import { render, staticRenderFns } from "./cta-global-settings.vue?vue&type=template&id=bebe04f0"
import script from "./cta-global-settings.vue?vue&type=script&lang=js"
export * from "./cta-global-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports